<template>
  <div class="change-context-container">
    <slot
      name="trigger"
      :handleDialog="handleDialog"></slot>
    <single-dialog
      :active="active"
      :large="false"
      :id="`change-context-single-dialog`"
      :key="`change-context-single-dialog`"
      @handleDialog="handleDialog"
      class="color-gray-dark">
      <template v-slot:header>
        <div class="col-xs-12 mt-20">
          <h4 class="col-xs-12">
            <template v-if="companies.length > 3">Busque uma empresa</template>
            <template v-else>Selecione uma empresa</template>
          </h4>
        </div>
      </template>
      <template
        v-slot:body>
        <div class="clearfix">
          <div class="col-xs-12 mb-40">
            <alert-helper
              :close="true"
              :type="'danger'"
              :alert="alert" />
            <form
              ref="form"
              @submit.prevent="handleSubmit">

              <!-- FILTER SEARCH -->
              <input-filter
                v-if="companies.length > 3"
                :key="`change-context-autocomplete-${active}`"
                :name="`change-context-autocomplete`"
                :placeholder="`Nome fantasia, razão social ou cnpj`"
                :list="companies"
                :listKey="'name,document_number,fantasy_name'"
                ico="fa-building"
                @handleInput="handleCompany" />
              <!-- // FILTER SEARCH -->

              <ul class="list-unstyled change-context-list">
                <li
                  v-for="(company, index) in companiesList"
                  :key="`change-context-form-radio-${index}`">
                    <p-radio
                      name="radio"
                      color="info"
                      :value="company.id"
                      v-validate="'required'"
                      v-model="radio"
                      focus="true"
                      tabindex="0">
                      <span class="change-context-list-item">
                        <span
                          v-if="company.logo"
                          class="change-context-list-logo">
                          <img :src="company.logo" alt="" />
                        </span>
                        <span class="change-context-list-text">
                          {{ company.name }}
                        </span>
                      </span>
                    </p-radio>
                </li>
              </ul>
              <div class="row mt-25 mb-15">
                <div class="col-sm-6 hidden-xs">
                  <button
                    @click="handleDialog"
                    class="btn-gray-inverse btn-block btn-extra-large"
                    type="button">
                    <i class="fa fa-fw fa-close"></i>Cancelar
                  </button>
                </div>
                <div class="col-sm-6">
                  <button
                    :disabled="submitted"
                    class="btn-blue btn-block btn-extra-large"
                    type="submit">
                    <i class="fa fa-fw fa-sign-in"></i>Alterar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </template>
    </single-dialog>
  </div>
</template>

<script>
import InputFilter from '@/components/fields/InputFilter'
import SingleDialog from '@/components/ui/SingleDialog'
import AlertHelper from '@/components/ui/AlertHelper'
import { mapActions } from 'vuex'

export default {
  components: {
    InputFilter,
    SingleDialog,
    AlertHelper
  },
  props: {
    companies: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      active: false,
      radio: null,
      submitted: false,
      alert: false,
      companiesList: []
    }
  },
  mounted () {
    // SET DEFAULT LIST
    this.$set(this, 'companiesList', this.companies)
  },
  watch: {
    companies (data) {
      // SET DEFAULT LIST
      this.$set(this, 'companiesList', data)
    }
  },
  methods: {
    ...mapActions('auth', [
      'postContextChange'
    ]),

    handleDialog () {
      this.alert = false
      this.active = !this.active;
      this.$refs.form.reset()
      this.$set(this, 'companiesList', this.companies)
    },

    handleSuccess () {
      this.handleDialog()
      this.submitted = false
      if (this.$route.path !== '/') this.$router.push('/')
    },

    handleError (error) {
      this.alert = (error.response)
        ? error.response.data
        : 'Não foi possível alterar o contexto. Por favor, tente novamente.'
      this.submitted = false
    },

    handleCompany (companies) {
      this.$set(this, 'companiesList', companies)
    },

    handleSubmit () {
      this.alert = false

      this.$validator.validate()
        .then(valid => {
          this.submitted = true

          if (valid) {
            this.postContextChange({ company_context: this.radio })
              .then(this.handleSuccess)
              .catch(this.handleError)
          }
      })
    }
  }
};
</script>

<style lang="scss">
@import '@/scss/components/template/ChangeContext';
</style>
